// extracted by mini-css-extract-plugin
export default {"root":"ApplicationsThisMonth_root__IjNmN","title":"ApplicationsThisMonth_title__9e4mp","link":"ApplicationsThisMonth_link__kg2H4","count":"ApplicationsThisMonth_count__oWVu0"};